import React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { SegmentsRow, SegmentColumn, SegmentValue } from '@/components/BbanPreview/StyledComponents';

export interface BbanSegment {
  caption: string;
  value: string;
}

interface BbanPreviewProps {
  label: string;
  segments: BbanSegment[];
}

const Segment: React.FC<BbanSegment> = ({ caption, value }) => (
  <SegmentColumn>
    <Typography variant="caption" color="text.secondary" noWrap>
      {caption}
    </Typography>
    <SegmentValue variant="body2">{value || '—'}</SegmentValue>
  </SegmentColumn>
);

// Read-only, segmented preview of an assembled account number (Bank / Branch /
// Account …). Presentational only — shared by the open_finance add-account form
// (DPM-545) and the beneficiary form; each wires its own values/labels in.
const BbanPreview: React.FC<BbanPreviewProps> = ({ label, segments }) => (
  <Box>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <SegmentsRow>
      {segments.map((segment) => (
        <Segment key={segment.caption} caption={segment.caption} value={segment.value} />
      ))}
    </SegmentsRow>
  </Box>
);

export default BbanPreview;
